module.exports = __webpack_public_path__ + "img/btc.7109f7a1.png";